import { render, staticRenderFns } from "./SolidGateWallet.vue?vue&type=template&id=38bcaccc&scoped=true"
import script from "./SolidGateWallet.vue?vue&type=script&lang=js"
export * from "./SolidGateWallet.vue?vue&type=script&lang=js"
import style0 from "./SolidGateWallet.vue?vue&type=style&index=0&id=38bcaccc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bcaccc",
  null
  
)

export default component.exports